<template>
    <div class="optpl-templates__group-container" v-if="shouldShowEmptyGroup">
        <div class="optpl-templates__group-heading">
            <h3>
                <span>
                    <span v-if="this.$route.params.type === 'templates-landing'">Landing Pages <i v-if="group.slug !== 'new-and-trending' && group.pagination">({{ group.pagination.total }} results)</i></span>
                    <span v-else-if="this.$route.params.type === 'templates-other'">Website Pages <i v-if="group.slug !== 'new-and-trending' && group.pagination">({{ group.pagination.total }} results)</i></span>
                    <span v-else-if="group.slug === 'templates'">Templates <i v-if="group.slug !== 'new-and-trending' && group.pagination">({{ group.pagination.total }} results)</i></span>
                    <span v-else> {{ group.title || 'Templates' }} <i v-if="group.slug !== 'new-and-trending' && group.pagination">({{ group.pagination.total }} results)</i></span>
                </span>
                <router-link :to="{ name: 'library', params: { type: 'templates'   }}"  v-if="group.slug === 'templates'    && ! $route.params.type">{{ $e('View all') }}</router-link>
                <router-link :to="{ name: 'library', params: { type: 'purchased'   }}"  v-if="group.slug === 'purchased'    && ! $route.params.type">{{ $e('View all') }}</router-link>
                <router-link :to="{ name: 'library', params: { type: 'collections' }}"  v-if="group.slug === 'collections'  && ! $route.params.type">{{ $e('View all') }}</router-link>
                <router-link :to="{ name: 'library', params: { type: 'marketplace' }}"  v-if="group.slug === 'marketplace'  && ! $route.params.type">{{ $e('View all') }}</router-link>
                <router-link :to="{ name: 'library', params: { type: 'my-templates' }}" v-if="group.slug === 'my-templates' && ! $route.params.type">{{ $e('View all') }}</router-link>
            </h3>
            <h4 v-if="subline">{{ subline }}</h4>
        </div>

        <div class="optpl-templates__list" v-if="group.items && group.items.length" :class="{ 'optpl-templates__list-purchasable': group.purchasable }">
            <ul>
                <li v-for="item in group.items">
                    <TemplateItem           :template="item"   v-if="item.type === 'template' || item.type === 'customer_template'" />
                    <TemplatePackItem       :item="item"       v-else-if="item.type === 'pack'" />
                    <TemplateCollectionItem :item="item"       v-else />
                </li>
            </ul>

            <div v-if="shouldShowLoadMoreButton" class="optpl-templates__load-more opui-text-center opui-my-4">
                <button @click="loadMore" class="opui-btn opui-btn-outline" :class="{ saving: loading, disabled: loading }" :disabled="loading">
                    <span v-if="loading">{{ $e('Loading more...') }}</span>
                    <span v-else>{{ $e('Load more') }}</span>
                </button>
            </div>
        </div>

        <div v-else>
            <NoResults />
        </div>
    </div>
</template>

<script>
import { useTemplatesStore } from "../../store/templates"
import { mapStores } from 'pinia'
import TemplateCollectionItem from './TemplateCollectionItem.vue';
import TemplateItem from './TemplateItem.vue';
import TemplatePackItem from './TemplatePackItem.vue';
import NoResults from "./NoResults.vue";

export default {
    components: { TemplateItem, TemplatePackItem, TemplateCollectionItem, NoResults },
    props: {
        group: { type: Object, required: true }
    },
    data() {
        return {
            loading: false,
            page:    1,
        }
    },
    computed: {
        ...mapStores(useTemplatesStore),
        shouldShowEmptyGroup() {
            if (this.group.items && this.group.items.length || this.$route.params.type) {
                return true
            }

            return false
        },
        shouldShowLoadMoreButton() {
            const type = this.$route.params.type || 'all'

            // Also calculate if we have any items to show
            const visible         = this.group.items && this.group.items.length
            const total           = this.group.pagination ? this.group.pagination.total : 0
            const availableToLoad = total - visible

            return (availableToLoad > 0 && type !== 'all');
        },

        subline() {
            let subline = ''

            if      (this.group.slug === 'new-and-trending') subline = "New and popular templates that are working now online";
            else if (this.group.slug === 'templates')        subline = "Entire library of templates for your next website or marketing campaign";
            else if (this.group.slug === 'purchased')        subline = "Templates you’ve purchased to use in OptimizePress";
            else if (this.group.slug === 'collections')      subline = "Complete sets of templates that use the same design and niche theme";
            else if (this.group.slug === 'marketplace')      subline = "Premium template collections available for you to purchase";
            else if (this.group.slug === 'my-templates')     subline = "Templates that you’ve saved from inside of the OptimizeBuilder";

            return subline
        }
    },
    methods: {
        async loadMore() {
            this.loading = true

            // Increment the page
            this.page = this.page + 1

            await this.templatesStore.fetchMoreTemplates(this.group.slug, {
                page: this.page
            })

            this.loading = false
        }
    }
}
</script>

<style scoped>
h3 span i {
    font-style: normal;
    font-size: 13px;
    color: #999;
}
</style>
